import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {
    isDirectReservation,
    isInternalReservation
} from "@hosttools/core/shared/utils/utils.reservation";
import type React from "react";
import {memo, useMemo} from "react";

import type {Reservation} from "../../models/reservation";
import {useChannel} from "../../react";
import {Avatar, AvatarFallbackText, AvatarImage} from "../ui/avatar";
import type {IAvatarProps} from "../ui/avatar";

type Props = {
    fullName?: string;
    channel: Reservation["source"];
    url?: string;
    size?: IAvatarProps["size"];
    className?: string;
};

const avatarStyles = tva({
    base: "border-white dark:bg-dark-muted"
});

const ChannelAvatar: React.FC<Props> = ({fullName, channel, url, size = "md", className}) => {
    const channelObject = useChannel(channel);
    const avatarSourceSrc = useMemo(() => {
        if (!fullName && (isInternalReservation(channel) || isDirectReservation(channel))) {
            return {uri: channelObject.logo};
        }
        return url ? {uri: url} : undefined;
    }, [channel, channelObject.logo, fullName, url]);

    return (
        <Avatar
            className={`${channelObject?.bgAvatarClassName} ${avatarStyles({className})}`}
            size={size}
        >
            <AvatarFallbackText className="text-white">{fullName}</AvatarFallbackText>
            {avatarSourceSrc?.uri && (
                <AvatarImage className="w-[70%] h-[70%]" source={avatarSourceSrc} />
            )}
        </Avatar>
    );
};

export default memo(ChannelAvatar);
